import { render } from "./EditDiagnosisBilling.vue?vue&type=template&id=32033b3c&scoped=true"
import script from "./EditDiagnosisBilling.vue?vue&type=script&lang=js"
export * from "./EditDiagnosisBilling.vue?vue&type=script&lang=js"

import "./EditDiagnosisBilling.vue?vue&type=style&index=0&id=32033b3c&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32033b3c"]])

export default __exports__